/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Emailplaceholder1Inputs */

const zh_share_emailplaceholder1 = /** @type {(inputs: Share_Emailplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮箱或群组，用逗号分隔`)
};

const en_share_emailplaceholder1 = /** @type {(inputs: Share_Emailplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email or group, separated by commas`)
};

const es_share_emailplaceholder1 = /** @type {(inputs: Share_Emailplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo o grupo, separados por comas`)
};

/**
* | output |
* | --- |
* | "Email or group, separated by commas" |
*
* @param {Share_Emailplaceholder1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_emailplaceholder1 = /** @type {((inputs?: Share_Emailplaceholder1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Emailplaceholder1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_emailplaceholder1(inputs)
	if (locale === "en") return en_share_emailplaceholder1(inputs)
	return es_share_emailplaceholder1(inputs)
});
export { share_emailplaceholder1 as "share_emailPlaceholder" }